import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql,useApolloClient } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
//import HtlAgnSeaReduction from "./HtlAgnSeaReduction";
//import HtlAgnSeasonPriceEdit from "./HtlAgnSeasonPriceEdit";
import HtlAgnOffresEdit from "../../../hoteladm/hotel/offers/HtlAgnOffresEdit";
import HtlAgnOffresGrp from "../../../hoteladm/hotel/offers/HtlAgnOffres";






import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12(
    $firmMainCode: String
    $firmSubCode: String
    $currentLocale: String
    $contIdSeq: Int!

  ) {
    tbl_cont_rules_def(
      order_by: { firm_main_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        cont_id: { _eq: $contIdSeq }
        
      }
    ) {
      firm_main_code
      firm_sub_code
      id_seq
      cont_id
      rules_grp_id
      rules_class
      rules_type
      rules_name
      rules_grp_class
    }
  }
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const GET_PER_DEFS = gql`
  query GetPerDefs($firmMainCode: String, 
                   $firmSubCode: String,
                   $contIdSeq: Int) {
    tbl_cont_per_def(where: {
      firm_main_code: { _eq: $firmMainCode }, 
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
    }) {
      id_seq
      period
      start_date
      end_date
      min_stay
      release
    }
  }
`;

const GET_PER_BASE = gql`
  query GetPerBase(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_cont_per_base(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq }
      },
      order_by: { room_type: asc } 
    ) {   
      per_id
      room_type
      get_room_name {
        r_type_name
      }
      base_price
      period
    }
  }
`;

const GET_RULE_SUB = gql`
  query GetRuleSub(
    $firmMainCode: String, 
    $firmSubCode: String,
    $rulPernId: Int
  ) {
    tbl_rules_sub(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        r_prn_id_seq: { _eq: $rulPernId },
        
      },
      order_by: { rules_sub_type: asc } 
    ) {   
        id_seq
        r_prn_id_seq
        firm_main_code
        firm_sub_code
        rules_sub_type
        rules_sub_name
        start_date
        end_date
        status
        active

    }
  }
`;

const GET_HTL_RULE = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $ruleClass: String
    $ruleType: String
    $rulesGrpClass: String
    
  ) {
    tbl_rules_prn(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        rules_class: { _eq: $ruleClass }
        rules_type: { _eq: $ruleType }
        rules_grp_class: { _eq: $rulesGrpClass }
       
      }
    ) {
     
        id_seq
        rules_class
        rules_type
        rules_name
        start_date
        end_date
        status
        active
       
    }
  }
`;


const GET_HTL_WEEK = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $ruleClass: String
    $ruleType: String
    $rulesGrpClass: String
    
  ) {
    tbl_rules_prn(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        rules_class: { _eq: $ruleClass }
        rules_type: { _eq: $ruleType }
        rules_grp_class: { _eq: $rulesGrpClass }
       
      }
    ) {
     
        id_seq
        rules_class
        rules_type
        rules_name
        start_date
        end_date
        status
        active
       
    }
  }
`;








const GET_HTL_SEA = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    
  ) {
    tbl_htl_season(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
       
      }
    ) {
     
        id_seq
        start_date
        end_date
        desc
        active
       
    }
  }
`;


const GET_HTL_PER = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $htlSeaIdSeq: Int
    
  ) {
    tbl_htl_period(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        sea_id_seq: { _eq: $htlSeaIdSeq }
       
      }
    ) {
     
        id_seq
        sea_id_seq
        period
        start_date
        end_date
        release
        min_stay
       
    }
  }
`;

const INSERT_HTL_PER_RECORDS_MUTATION = gql`
  mutation InsertHtlPerRecordsIntoContPer($records: [tbl_cont_per_def_insert_input!]!) {
    insert_tbl_cont_per_def(objects: $records) {
      affected_rows
    }
  }
`;

const GET_HTL_SEA2 = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $htlSeaIdSeq: Int
    
  ) {
    tbl_htl_season(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        
       
      }
    ) {
     
        id_seq
        start_date
        end_date
        desc
        active
       
    }
  }
`;
const INSERT_CONT_RULE = gql`
  mutation InsertContractSea(
    $contSeaIdSeq: Int!
    $contIdSeq: Int!
    $htlSeaIdSeq: Int!
    $firmMainCode: String
    $firmSubCode: String
    $rulesClass: String
    $rulesType: String
    $rulesGrpClass: String
   
  ) {
    insert_tbl_cont_rules_def(
      objects: {
        id_seq: $contSeaIdSeq,
        cont_id: $contIdSeq,
        rules_grp_id: $htlSeaIdSeq,
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        rules_class: $rulesClass,
        rules_type: $rulesType,
        rules_grp_class: $rulesGrpClass,
       
      
      }
    ) {
      affected_rows
    }
  }
`;

const GET_TBL_CONT_PER_DEF = gql`
  query GetTblContPerDef(
        $firmMainCode: String,
        $firmSubCode: String,
        $contIdSeq: Int
        ) {
    tbl_cont_per_def(where: {
                firm_main_code: { _eq: $firmMainCode }, 
                firm_sub_code: { _eq: $firmSubCode },
                cont_id: { _eq: $contIdSeq }
             }) {
      id_seq
      cont_id
      firm_main_code
      firm_sub_code
      start_date
      end_date
      period
      min_stay
      release
      get_room_types {
        r_class_code
        r_type_code
      }
    
    }
  }
`;

const GET_TBL_CONT_PER_DEF2 = gql`
  query GetTblContPerDef {
    tbl_cont_per_def {
      id_seq
      firm_main_code
      firm_sub_code
      start_date
      end_date
      period
      get_room_types {
        r_class_code
        r_type_code
      }
    }
  }
`;

const INSERT_HTL_PER_RECORDS_MUTATION_N2 = gql`
  mutation InsertHtlPerRecordsIntoContPerBase($records: [tbl_cont_per_def_base_insert_input!]!) {
    insert_tbl_cont_per_base(objects: $records) {
      affected_rows
    }
  }
`;

const INSERT_HTL_PER_RECORDS_MUTATION_N = gql`
  mutation InsertHtlPerRecordsIntoContPerBase($records: [tbl_cont_per_base_insert_input!]!) {
    insert_tbl_cont_per_base(objects: $records) {
      affected_rows
    }
  }
`;

const INSERT_TBL_CONT_PER_BASE_MUTATION = gql`
  mutation InsertTblContPerBase($records: [TblContPerBaseInput!]) {
    insert_tbl_cont_per_base(objects: $records) {
      affected_rows
    }
  }

  input TblContPerBaseInput {
    cont_id: Int!
   
  }
`;

const UPDATE_BASE_PRICE = gql`
mutation UpdateContBasePrice(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
  $contSeaIdSeq: Int
  $basePeriod: String
  $roomType: String
  $basePrice: float8 
  
) {
  update_tbl_cont_per_base(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
      sea_id: { _eq: $contSeaIdSeq }
      period: { _eq: $basePeriod }
      room_type: { _eq: $roomType }
    },
    _set: {
     base_price: $basePrice,
     
    }
  ) {
    affected_rows
  }
}
`;

const DELETE_PER_PRICE = gql`
mutation DeleteContBasePrice(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
) {
  delete_tbl_cont_per_price(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
    }
  ) {
    affected_rows
  }
}
`;

const DELETE_PER_GRP = gql`
mutation DeleteContPerGrp(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
) {
  delete_tbl_cont_per_grp(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
    }
  ) {
    affected_rows
  }
}
`;




  const GET_PER_BASE_CALC = gql`
  query GetPerBase(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_cont_per_base(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq }
      },
      order_by: { room_type: asc } 
    ) {   
      per_id
      room_type
      base_price
      period
    }
  }
`;

const GET_PER_RED_CALC = gql`
  query GetPerPer(
    $firmMainCode: String,
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_cont_per_per(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq }
      },
      order_by: { id_seq: asc }
    ) {
      id_seq
      cont_id
      per_id
      period
      person
      person_type
      red_sup_type
      percent
      rooms
    }
  }
`;

const INSERT_CONT_PER_PRICE_CALC = gql`
  mutation InsertContractPerPriceCalc(
     $redIdSeq: Int!,
     $contId: Int,
     $perRoomClass: String,
     $firmMainCode: String,
     $firmSubCode: String,
     $perId: Int,
     $adult: Int,
     $child: Int,
     $perPrice: float8,
     $currency: String,
     $period: String,
     $perRooms: String!) {
    insert_tbl_cont_per_price(objects: { 
       red_id: $redIdSeq, 
       cont_id: $contId,
       per_id: $perId,
       periot: $period,
       adult: $adult,
       child: $child,
       per_price: $perPrice,
       currency: $currency,
       firm_main_code: $firmMainCode,
       firm_sub_code: $firmSubCode,
       r_class_code: $perRoomClass,
       r_type_code: $perRooms }) {
      affected_rows
    }
  }
`;


const GET_HTL_WEEK_DAYS = gql`
  query GET_HTL_WEEK_DAYS($firmMainCode: String!, $firmSubCode: String!, $htlSeaIdSeq: Int) {
    tbl_rules_sub_premises(where: 
      {firm_main_code: {_eq: $firmMainCode},
       firm_sub_code: {_eq: $firmSubCode},
       r_prn_id_seq: {_eq:$htlSeaIdSeq},
       r_sub_type: {_eq: WDAY},
      
      
      })
       
       {
      id_seq
      firm_main_code
      firm_sub_code
      r_prn_id_seq
      r_sub_id_seq
      pre_type
      int_var_1
      get_act_one_one {
      int_var_1
      }
    }
  }
`;

const GET_HTL_SPECIAL_DAYS = gql`
  query GET_HTL_WEEK_DAYS($firmMainCode: String!, $firmSubCode: String!, $htlSeaIdSeq: Int) {
    tbl_rules_sub_premises(where: 
      {firm_main_code: {_eq: $firmMainCode},
       firm_sub_code: {_eq: $firmSubCode},
       r_prn_id_seq: {_eq:$htlSeaIdSeq},
       r_sub_type: {_eq: SDAY},
      
      
      })
       
       {
      id_seq
      firm_main_code
      firm_sub_code
      r_prn_id_seq
      r_sub_id_seq
      pre_type
      start_date_v1
      end_date_v1
       get_act_one_one {
      int_var_1
      }
    }
  }
`;


const GET_SALES_PLAN_DATA = gql`
  query GetCurrentData(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int,
  
  ) {
    tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },
       
       
         
      },
      order_by: { price_date: asc } 
    ) {   
        cont_id         
        r_type_code
        per_price
        currency
        price_date
        firm_main_code
        firm_sub_code
        adult
        week_rule_id
        week_rule_action_value
    }
  }
`;

const GET_SALES_PLAN_DATA22 = gql`
  query GetCurrentData(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int,
  
  ) {
    tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },
       
       
         
      },
      order_by: { price_date: asc } 
    ) {   
        cont_id         
        r_type_code
        per_price
        currency
        price_date
        firm_main_code
        firm_sub_code
        adult
        week_rule_id
        week_rule_action_value
    }
  }
`;


const UPDATE_SALES_PLAN_DATA = gql`
mutation UpdateSalesPlanData($priceDate: date!, $newWeekRuleActionValue: Int!, $weekRuleId: Int!, $perPrice: float8) {
  update_tbl_cont_per_price(
    where: { 
      price_date: { _eq: $priceDate }
    }
    _set: {
      week_rule_action_value: $newWeekRuleActionValue,
      week_rule_id: $weekRuleId,
     
    }
  ) {
    affected_rows
    returning {
      cont_id
      price_date
      week_rule_action_value
      week_rule_id
      per_price
    }
  }
}
`;


const UPDATE_SALES_PLAN_DATA22 = gql`
mutation UpdateSalesPlanData($priceDate: date!,
                              $newSpecialkRuleActionValue: Int!,
                               $specialRuleId: Int!,
                               $perPrice: float8) {
  update_tbl_cont_per_price(
    where: { 
      price_date: { _eq: $priceDate }
    }
    _set: {
      sepecial_day_action_value: $newSpecialkRuleActionValue,
      special_day_rule_id: $specialRuleId,
      
    }
  ) {
    affected_rows
    returning {
      cont_id
      price_date
      sepecial_day_action_value
      special_day_rule_id
      per_price
    }
  }
}
`;

const GET_SALES_PLAN_DATA_FOR_WEEK = gql`
  query GetCurrentData(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },
        week_rule_action_value: { _gt: 0 } 
      },
      order_by: { price_date: asc } 
    ) {   
        cont_id         
        r_type_code
        per_price
        currency
        price_date
        firm_main_code
        firm_sub_code
        adult
        week_rule_id
        week_rule_action_value
    }
  }
`;

const GET_SALES_PLAN_DATA_FOR_SPECIAL_DAY = gql`
  query GetCurrentData(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },
        sepecial_day_action_value: { _gt: 0 } 
      },
      order_by: { price_date: asc } 
    ) {   
        cont_id         
        r_type_code
        per_price
        currency
        price_date
        firm_main_code
        firm_sub_code
        adult
        special_day_rule_id
        sepecial_day_action_value
    }
  }
`;

const UPDATE_BASE_PRICE_FOR_WEEK = gql`
  mutation UpdateContBasePrice(
    $contIdSeq: Int
    $firmMainCode: String
    $firmSubCode: String
    $basePricePersent: float8
    $rTypeCodeSelect: String
    $startDate: date
    $endDate: date
    $newPerPrice: float8
    $adl: Int
  ) {
    update_tbl_cont_per_price(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },   
        r_type_code: { _eq: $rTypeCodeSelect },
        adult: { _eq: $adl },
        price_date: { _gte: $startDate, _lte: $endDate },   
      },
      _set: {
        per_price: $newPerPrice
        base_price: $newPerPrice

      }
    ) {
      affected_rows
    }
  }
`;

const GET_PRICES = gql`
  query MyQuery2($contIdSeq: Int!, $firmMainCode: String!, $firmSubCode: String!) {
    tbl_cont_per_grp(where: {
      cont_id: { _eq: $contIdSeq },
      firm_main_code: { _eq: $firmMainCode },
      firm_sub_code: { _eq: $firmSubCode }
    }) {
      id_seq
      firm_main_code
      firm_sub_code
      per_id
      cont_id
      rooms
      grp_per {
        cont_id
        id_seq
        per_id
        percent
        period
        person
        rooms
        red_sup_type
        person_type
      }
      grp_base {
        cont_id
        per_id
        period
        room_type
        base_price
        currency
      }
    }
  }
`;


const INSERT_HTL_PER_RECORDS_MUTATION_PRICE = gql`
  mutation InsertPrice($records: [tbl_cont_per_price_insert_input!]!) {
    insert_tbl_cont_per_price(objects: $records) {
      affected_rows
    }
  }
`;











const HtlAutoSalesOffres = () => {
    const { users } = useContext(UserContext);
    const { firmcode, subfirmcode, usertype, userLang } = users;
    const { id_seq } = useParams();
    const {varCode3, setVarCode3} = useContext(ThemeContext);
    const {varCode4, setVarCode4} = useContext(ThemeContext);
    const {varCode5, setVarCode5} = useContext(ThemeContext);
    const {varCode6, setVarCode6} = useContext(ThemeContext);
    const {varCode7, setVarCode7} = useContext(ThemeContext);
    const {varCode8, setVarCode8} = useContext(ThemeContext);
    const [someCondition, setSomeCondition] = useState(false);

    const {varCode, setVarCode} = useContext(ThemeContext);
    
    const {varCode9, setVarCode9} = useContext(ThemeContext);
    const {varCode10, setVarCode10} = useContext(ThemeContext);
    const {varCode11, setVarCode11} = useContext(ThemeContext);
    const {varCode12, setVarCode12} = useContext(ThemeContext);
    const {varCode14, setVarCode14} = useContext(ThemeContext);
   
    
    const firmMainCode = firmcode;
    const firmSubCode = subfirmcode;
    const intl = useIntl();
    const currentLocale = userLang || localStorage.getItem('lang') || 'en';
  
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const [activeTabS, setActiveTabS] = useState(9);
  
    const handleTabChange = (index) => {
      setActiveTab(index);
    };
  
    const handleTabChangeS = (index) => {
      setActiveTabS(index);
    };
  
    const { loading, error, data, refetch } = useQuery(GET_POST, {
      variables: { firmSubCode, firmMainCode, contIdSeq: varCode4 },
    });
  
    const ownFirmMainCode = firmcode;
    const ownFirmSubCode = subfirmcode;
    const ownFirmSubType = usertype;
  
   // const [UpdateContract] = useMutation(UPDATE_CONT);
    const [InsertContractSea] = useMutation(INSERT_CONT_RULE);
    const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2);
    const [insertPerRecords] = useMutation(INSERT_HTL_PER_RECORDS_MUTATION);
    const [insertPerBaseRecords] = useMutation(INSERT_HTL_PER_RECORDS_MUTATION_N);
    const [insertPerBaseRecords2] = useMutation(INSERT_HTL_PER_RECORDS_MUTATION_PRICE);

   
   
   
   
    const [insertContPerBase] = useMutation(INSERT_TBL_CONT_PER_BASE_MUTATION);
  const { loading: tblContPerDefLoading, error: tblContPerDefError, data: tblContPerDefData } = useQuery(GET_TBL_CONT_PER_DEF);
    



    // useMutation'ı bileşen içinde kullanın
    
 
  
  
    const firmData = data && data.tbl_cont_rules_def ? data.tbl_cont_rules_def[0] : null;

    const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.cont_id :"");
    const [contSeaIdSeq, setContSeaIdSeq] = useState(firmData ? firmData.id_seq :"");
    const [htlSeaIdSeq, setHtlSeaIdSeq] = useState(firmData ? firmData.rules_grp_id :"");

    const [contRuleId, setContRuleId] = useState(firmData ? firmData.id_seq :"");
    const [htlRuleId, setHtlRuleId] = useState(firmData ? firmData.rules_grp_id :"");
    const [rulesGrpClass, setRulesGrpClass] = useState(firmData ? firmData.rules_grp_class :"");
    
    const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
    const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

    
    const [UpdateContBasePrice] = useMutation(UPDATE_BASE_PRICE);
    const [DeleteContBasePrice] = useMutation(DELETE_PER_PRICE);
    const [DeleteContPerGrp] = useMutation(DELETE_PER_GRP);

    const [basePeriod, setBasePeriod] = useState();
    const [roomType, setRoomType] = useState();
    const [basePrice, setBasePrice] = useState();
    const [basePricetrg, setBasePriceTrg] = useState(1);
    const [idSeqtrg, setIdSeqTrg] = useState();
   

   // <HtlAgnContractEdit contCurrency={currency} setContCurrency={setCurrency} />  

   

 
   const detail = messages[currentLocale].detail;
   const activerec = messages[currentLocale].activerec;
   const inactiverec = messages[currentLocale].inactiverec;
    
  


      const { loading: htlRuleLoading, error: htlRuleError, data: htlRuleData, refetch: refetcGetHtlRule } = useQuery(GET_HTL_RULE, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, ruleClass: "RHTL", ruleType: "HSAL" , rulesGrpClass: rulesGrpClass },
      });


    

  const cont_detail_tab = messages[currentLocale].cont_detail_tab;

  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);


  const { loading: loadingRuleSub, error: perRuleSubError, data: perRuleSubData, refetch: refetchRuleSub } = useQuery(GET_RULE_SUB, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, rulPernId: htlSeaIdSeq },
  });



  const firmData2 = perRuleSubData && perRuleSubData.tbl_rules_sub;


  const { loading: loadingRuleSub2, error: perRuleSubError2, data: perRuleSubData2, refetch: refetchRuleSub22} = useQuery(GET_SALES_PLAN_DATA, {
    variables: { 
        firmMainCode, 
        firmSubCode, 
        contIdSeq: varCode4, 
     
    },
    fetchPolicy: 'network-only', // Her zaman ağı kullanarak yeniden sorgula
});



const { loading: loadingRuleSub222, error: perRuleSubError222, data: perRuleSubData222, refetch: refetchRuleSub222} = useQuery(GET_SALES_PLAN_DATA_FOR_WEEK, {
  variables: { 
      firmMainCode, 
      firmSubCode, 
      contIdSeq: varCode4, 
   
  },
  fetchPolicy: 'network-only', // Her zaman ağı kullanarak yeniden sorgula
});

const { loading: loadingRuleSub2222, error: perRuleSubError2222, data: perRuleSubData2222, refetch: refetchRuleSub2222} = useQuery(GET_SALES_PLAN_DATA_FOR_SPECIAL_DAY, {
  variables: { 
      firmMainCode, 
      firmSubCode, 
      contIdSeq: varCode4, 
   
  },
  fetchPolicy: 'network-only', // Her zaman ağı kullanarak yeniden sorgula
});

const { loading: loadingRoomFactor, error: roomFactorError, data: roomFactorData } = useQuery(GET_HTL_WEEK_DAYS, {
  variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, htlSeaIdSeq: htlSeaIdSeq },
});


const { loading: loadingRuleSub22, error: perRuleSubError22, data: perRuleSubData22, refetch: refetchRuleSub2} = useQuery(GET_SALES_PLAN_DATA22, {
  variables: { 
      firmMainCode, 
      firmSubCode, 
      contIdSeq: varCode4, 
   
  },
  fetchPolicy: 'network-only', // Her zaman ağı kullanarak yeniden sorgula
});


const { loading: loadingspecialDays, error: specialDaysError, data: specialDaysData } = useQuery(GET_HTL_SPECIAL_DAYS, {
  variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, htlSeaIdSeq: htlSeaIdSeq },
});

const [triggerUpdate, setTriggerUpdate] = useState(false);
const [triggerUpdate2, setTriggerUpdate2] = useState(false);

const onClickCalc = () => {
  setTriggerUpdate(true); 
};

// triggerUpdate değiştiğinde sorguyu yeniden çağır
useEffect(() => {
  if (triggerUpdate) {
    handleUpdate();
  }
}, [triggerUpdate, setTriggerUpdate]);

const onClickCalc2 = () => {
  setTriggerUpdate2(true); 
};

// triggerUpdate değiştiğinde sorguyu yeniden çağır
useEffect(() => {
  if (triggerUpdate2) {
    handleUpdate2();
  }
}, [triggerUpdate2, setTriggerUpdate2]);



const [updateSalesPlanData] = useMutation(UPDATE_SALES_PLAN_DATA);
const [updateSalesPlanData22] = useMutation(UPDATE_SALES_PLAN_DATA22);


const handleUpdateButtonClick = () => {
  console.log("Butona tıklandı!");
  
  console.log("roomFactorData:", roomFactorData);

  if (!loadingRuleSub2 && !perRuleSubError2 && perRuleSubData2 && roomFactorData && roomFactorData.tbl_rules_sub_premises) {
    let allUpdatesCompleted = true;

    roomFactorData.tbl_rules_sub_premises.forEach(weekDayInfo => {
      console.log("weekDayInfo:", weekDayInfo);

      perRuleSubData2.tbl_cont_per_price.forEach(priceData => {
        console.log("price", priceData);
        const perPricegelen = (priceData.per_price);
        // Fiyatın tarihini haftanın gününe dönüştür ve ona göre kontrol et
        const priceDate = new Date(priceData.price_date);
        const priceWeekday = priceDate.getDay(); // 0 (Pazar) - 6 (Cumartesi) arası bir sayı döner

        // Haftanın günü ile fiyatın gününü karşılaştır
        if (priceWeekday === weekDayInfo.int_var_1) {
          console.log("Fiyat haftanın gününe denk geliyor:", weekDayInfo.pre_type);

          // Fiyatı güncelle
          updateSalesPlanData({
            variables: {
              priceDate: priceData.price_date,
              newWeekRuleActionValue: weekDayInfo.get_act_one_one.int_var_1,
              weekRuleId: weekDayInfo.id_seq,
              
            }
          }).then(response => {
            console.log("Güncelleme başarılı:", response);
          }).catch(error => {
            console.error("Güncelleme hatası:", error);
            allUpdatesCompleted = false;
          });
        } else {
          console.log("Fiyat haftanın gününe denk gelmiyor:", priceData.price_date);
        }
      });
    });

    if (allUpdatesCompleted) {
    
      console.log("Tüm güncellemeler tamamlandı.");
     
      onClickCalc();
      
    } else {
      console.log("Bazı güncellemeler tamamlanamadı.");
    }
  } else {
    console.error("Veri alınamadı veya eksik.");
  }
};

const [updateContBasePrice] = useMutation(UPDATE_BASE_PRICE_FOR_WEEK);

const handleUpdate = async () => {
  
  console.log(triggerUpdate);
  try {
    const { loading: loadingRuleSub222, data: perRuleSubData222 } = await refetchRuleSub222(); // Sorguyu yeniden yap
    
    
    if (loadingRuleSub222) {
      console.log("Veri yükleniyor...");
      return;
    }
    
    if (!perRuleSubData222) {
      console.log("Veri henüz yüklenmedi.");
      return;
    }
  
    // Veri yüklendiyse ve uygunsa, güncelleme işlemini gerçekleştir
    for (let i = 0; i < perRuleSubData222.tbl_cont_per_price.length; i++) {
      const row = perRuleSubData222.tbl_cont_per_price[i];
      const newPerPrice = calculateNewPerPrice(row.per_price, row.week_rule_action_value);

      const result = await updateContBasePrice({
        variables: {
          contIdSeq: row.cont_id,
          firmMainCode: row.firm_main_code,
          firmSubCode: row.firm_sub_code,
          rTypeCodeSelect: row.r_type_code,
          startDate: row.price_date,
          endDate: row.price_date,
          adl: row.adult,
          newPerPrice: newPerPrice,
          personFactor: row.person_factor,
        },
      });

      console.log("Result:", result);
      setTriggerUpdate(false);
    }
  } catch (error) {
    console.error("Hata oluştu:", error);
  }
  handleUpdateButtonClick22();
};
//paametreler sirasi ile aliniyor

const calculateNewPerPrice = (perPrice, weekPercent) => {

    return perPrice + (perPrice * weekPercent / 100);
  
};

const handleUpdateButtonClick22 = async () => {
  console.log("Butona tıklandı!");

  const salesPlanData = perRuleSubData22;
  let allUpdatesCompleted = true;

  try {
    // Satış planı verilerini alma
    await Promise.all([loadingRuleSub22, loadingspecialDays]);

    if (specialDaysData && specialDaysData.tbl_rules_sub_premises && salesPlanData && salesPlanData.tbl_cont_per_price) {
      // Her bir özel gün kaydını döngüye al
      for (const specialDay of specialDaysData.tbl_rules_sub_premises) {
        console.log("Özel gün:", specialDay);

        // Her bir satış planı kaydını döngüye al
        for (const salesPlan of salesPlanData.tbl_cont_per_price) {
          const salesPlanDate = new Date(salesPlan.price_date);

          // Özel günün tarih aralığını kontrol et
          const specialDayStartDateV1 = new Date(specialDay.start_date_v1);
          const specialDayStartDateV2 = new Date(specialDay.end_date_v1);

          if (salesPlanDate >= specialDayStartDateV1 && salesPlanDate <= specialDayStartDateV2) {
            // Satış planı kaydını güncelle
            try {
              await updateSalesPlanData22({
                variables: {
                  priceDate: salesPlan.price_date,
                  newSpecialkRuleActionValue: specialDay.get_act_one_one.int_var_1,
                  specialRuleId: specialDay.id_seq,
               
                }
              });

              console.log("Satış planı güncellendi:", salesPlan.price_date);
            } catch (error) {
              console.error("Güncelleme hatası:", error);
              allUpdatesCompleted = false;
            }
          }
        }
      }

      if (allUpdatesCompleted) {
        console.log("Tüm güncellemeler tamamlandı.");
        onClickCalc2();
        
      } else {
        console.log("Bazı güncellemeler tamamlanamadı.");
      }
    } else {
      console.error("Veri alınamadı veya eksik.");
    }
  } catch (error) {
    console.error("Bir hata oluştu:", error);
  }
};

const handleUpdate2 = async () => {
  try {
  
    const { loading: loadingRuleSub2222, data: perRuleSubData2222 } = await refetchRuleSub2222();
    // Her bir satırı döngüye alarak güncelleme işlemi
    for (let i = 0; i < perRuleSubData2222.tbl_cont_per_price.length; i++) {
      const row = perRuleSubData2222.tbl_cont_per_price[i];
      const newPerPrice = calculateNewPerPrice2(row.per_price, row.sepecial_day_action_value); //  bu parametreleri sirasi ile gonderiliyor unutma

      // Güncelleme mutasyonunu çağır
      const result = await updateContBasePrice({
        variables: {
          contIdSeq: row.cont_id,
          firmMainCode: row.firm_main_code,
          firmSubCode: row.firm_sub_code,
         
          rTypeCodeSelect: row.r_type_code,
          startDate: row.price_date,
          endDate: row.price_date,
          adl: row.adult,
          newPerPrice: newPerPrice,
          personFactor: row.person_factor,
        },
      });

     
      console.log("Result:", result);
      
    }
   
    
  } catch (error) {
    console.error("Error updating rows:", error);
    setTriggerUpdate2(false);
    console.log(error.message); 
  }
 
  console.log(triggerUpdate2);
};// parametreleri sirasi ile aliyor unutma

const calculateNewPerPrice2 = (perPrice, specialPercent) => {

    return perPrice + (perPrice * specialPercent / 100);
  
};
/*
const handleUpdateButtonClick = () => {
  console.log("Butona tıklandı!");
  console.log("perRuleSubData2:", perRuleSubData2);
  if (!loadingRuleSub2 && !perRuleSubError2 && perRuleSubData2 && roomFactorData && roomFactorData.tbl_rules_sub_premises) {
    const weekDayInfo = roomFactorData.tbl_rules_sub_premises[0]; // Haftanın gününe dair bilgiyi al
    console.log("weekDayInfo:", weekDayInfo);
    perRuleSubData2.tbl_cont_per_price.forEach(priceData => {
      console.log("price", priceData);
      updateSalesPlanData({
        variables: {
          priceDate: priceData.price_date,
          newWeekRuleActionValue: weekDayInfo.get_act_one_one.int_var_1,
          weekRuleId: weekDayInfo.id_seq
        }
      }).then(response => {
        console.log("Güncelleme başarılı:", response);
      }).catch(error => {
        console.error("Güncelleme hatası:", error);
      });
    });
  } else {
    console.error("Veri alınamadı veya eksik.");
  }
};*/

// const firmData2 = perRuleSubData && perRuleSubData.tbl_rules_sub ? perRuleSubData.tbl_rules_sub[0] : null;

  


  /* her bir kayıt icin id_seq al

  const handleUpdateIdSeq3 = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      return updatedIdSeq;
    } catch (error) {
      console.error('Güncelleme hatası:', error);
      throw error; // Hata durumunda dışarı at
    }
  };

  const handleInsertBaseRecords = async () => {
    try {
      // tbl_temp tablosundan çekilen veriler döngü 
      const recordsToInsert = [];
  
      for (const record of htlperroomData.tbl_cont_per_def) {
        // Her bir satır için ayrı bir ID_SEQ al
        const updatedIdSeq = String(await handleUpdateIdSeq3());
  
        // get_room_types'tan gelen tüm elemanları işle
        const roomTypeRecords = record.get_room_types.map((roomType) => ({
          cont_id: contIdSeq,
          firm_main_code: firmMainCode,
          firm_sub_code: firmSubCode,
          sea_id: contSeaIdSeq,
          per_id: record.id_seq,
          room_class: roomType.r_class_code,
          room_type: roomType.r_type_code,
          period: record.period,
          start_date: record.start_date,
          end_date: record.end_date,
          currency: updatedIdSeq,
          min_stay: record.min_stay,
          release: record.release,
        }));
  
        //  her bir eleman recordsToInsert dizisine ekle
        recordsToInsert.push(...roomTypeRecords);
      }
  
      // insertTempRecords mutasyon data insert tbl_dpr_main 
      const { data: insertData } = await insertPerBaseRecords({
        variables: { records: recordsToInsert },
      });
  
      const affectedRows = insertData.insert_tbl_cont_per_base.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_dpr_main.`);
      //handleInsertTempRecords2();
      refetch();
      refetchPerDefs2();
      refetchPerDefs();
      window.alert("Contract Season Base insert successfully!");
    } catch (error) {
      console.error('Error inserting into tbl_dpr_main:', error);
    
    }
  }; */










  const handleBasePriceUpdate = () => {
    UpdateContBasePrice({
      variables: {
        contIdSeq: contIdSeq,
        contSeaIdSeq: contSeaIdSeq,
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        basePeriod: basePeriod,
        roomType: roomType,
        basePrice: basePrice,
       

        
      },
    })
      .then(() => {
        window.alert("Contract Base updated successfully!");
        refetch();
        
      
       
      })
      .catch((error) => {
        console.error("Error updating Cont Base Price:", error);
      });
  };

  


    

    useEffect(() => {
        if (firmData) {  
               

          setContIdSeq(varCode4);
       // setContIdSeq(firmData.cont_id);
          setContSeaIdSeq(firmData.id_seq);
          setHtlSeaIdSeq(firmData.rules_grp_id);
          setRulesGrpClass(firmData.rules_grp_class);
          setStartDate(new Date(firmData.start_date));
          setEndDate(new Date(firmData.end_date));
          refetch();  
          
    
        }
      }, [firmData]);


   


    /*  useEffect(() => {
        if (!htlseaLoading2 && htlseaData2) {
          const htlSeaData = htlseaData2.tbl_htl_season[0]; // İlk öğeyi al, eğer varsa
    
          if (htlSeaData) {
            // Tarihleri set et
            setStartDate(new Date(htlSeaData.start_date));
            setEndDate(new Date(htlSeaData.end_date));
          }
        }
      }, [htlSeaIdSeq]);*/

      

      const [selectedRowData, setSelectedRowData] = useState(null);
      

 


   


      const handleUpdateIdSeq2 = async () => {
        try {
          const { data } = await updateIdSeq2({
            variables: {
              type: 'MFIRM', 
            },
          });
          const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
          console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
          setContSeaIdSeq(updatedIdSeq); 
          
          
         
         // setVarCode(updatedIdSeq.toString());  
          console.log(contSeaIdSeq);         
           
          
        } catch (error) {
          console.error('Güncelleme hatası:', error);
        }
      };


      const handleUpdateIdSeq = async () => {
        const requiredFields = ['htlSeaIdSeq' ]; // Required fiels
        const customFieldNames = {
            htlSeaIdSeq: "Hotel Offer Kodu"
        
    
        };
        const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
      
        if (emptyFields.length === 0) {
          try {
            const { data } = await updateIdSeq2({
              variables: {
                type: 'MFIRM', 
              },
            });
            const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
            console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
            setContSeaIdSeq(updatedIdSeq); 
            setContRuleId(updatedIdSeq);  
            setIdSeqTrg(updatedIdSeq);
            
            console.log(contSeaIdSeq);
            // setVarCode(updatedIdSeq.toString());  
          } catch (error) {
            console.error('Güncelleme hatası:', error);
          }
        } else {
          
          const emptyFieldsMessage = `Lütfen Hotel Offer Kodunu Seçin: ${emptyFields.join(', ')}`;
         // console.log(emptyFieldsMessage);
          window.alert(emptyFieldsMessage);
        }
      };
      
      const validateForm = (requiredFields, customFieldNames) => {
        // Tüm gerekli alanları kontrol et
        for (const field of requiredFields) {
          if (!eval(field)) {
            return false;
          }
        }
      
        return true;
      };
      
      const getEmptyFields = (requiredFields, customFieldNames) => {
        const emptyFields = [];
      
        // Boş olan alanları bul
        for (const field of requiredFields) {
          if (!eval(field)) {
            emptyFields.push(customFieldNames[field]);
          }
        }
      
        return emptyFields;
      };
    

      useEffect(() => {
       
            
          refetcGetHtlRule();  
        
     
      }, [rulesGrpClass]);
    
        useEffect(() => {
       
        if (idSeqtrg !== '') {          
          handleinsert();  
        
        }
      }, [idSeqtrg]);

      useEffect(() => {
        // varCode4 değiştiğinde yapılacak işlemler
        setContIdSeq(varCode4);
        setVarCode4(varCode4);
        setSomeCondition(true);
        console.log("var:", varCode4)
        
        // refetch fonksiyonunu çağırma koşullarına bağlı olarak
        if (someCondition) {
          refetch();
         
        }
      }, [varCode4, setContIdSeq, someCondition]);


          

      const handleinsert = () => {
        InsertContractSea({
         variables: {
           firmSubCode: firmSubCode,
           firmMainCode: firmMainCode,           
           contIdSeq: varCode4,
           contSeaIdSeq: contSeaIdSeq,
           htlSeaIdSeq: htlSeaIdSeq,
           rulesClass: "HTL",
           rulesType: "HSD",
           rulesGrpClass: rulesGrpClass,
         
          
         },
       })
         .then(() => {
           window.alert("  insert successfully!");
           handleUpdateButtonClick();
          
           refetch();
        
         })
         .catch((error) => {
           console.error("Error insert cont Season:", error);
         });
     };


  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };
      
      


         

       /*       useEffect(() => {
                if (htlseaData && htlSeaIdSeq) {
                  const selectedSea = htlseaData.tbl_htl_season.find(sea => sea.id_seq === htlSeaIdSeq);
                  
                  if (selectedSea) {
                    setStartDate( new Date(selectedSea.start_date));              
                    setEndDate( new Date(selectedSea.end_date));
                  }
              
                  console.log("start date:", selectedSea ? selectedSea.start_date : null);
                }
              }, [htlSeaIdSeq, htlseaData]); */
          

       /*   const htlRuleItems = htlRuleData && htlRuleData.tbl_rules_prn
          ? htlRuleData.tbl_rules_prn.map(item => ({
              label: item.rules_name,
              value: item.id_seq,
              name: item.rules_name, 
            }))
          : []; */

          const [displayBasic, setDisplayBasic] = useState(false);

          const onClick = () => {
          //  setVarCode11(ruleType); //EBO
          //  setVarCode8(rulSubId);
            setDisplayBasic(true);
            
          };

          const onHide = () => {
            setDisplayBasic(false);
            refetch();
            refetchRuleSub();
            
          };


          const [displayBasic2, setDisplayBasic2] = useState(false);

          const onClick2 = () => {
            // setVarCode11(ruleType); // EBO
            // setVarCode8(rulSubId);
           refetch();
            if (htlSeaIdSeq !== null) {
              setVarCode(htlSeaIdSeq);
              
            } else {
              setVarCode(0);
            }
            setVarCode14(rulesGrpClass);
            setDisplayBasic2(true);
          };

          const onHide2 = () => {
            refetcGetHtlRule();
            refetchRuleSub();
            setDisplayBasic2(false);
           
          };

          const rulesGrpClassSelectItems = [
            {label: 'Hotel', value: 'PUBL'},
            {label: 'Custom', value: 'PRIV'},
             
          ];


          const htlRuleItems = htlRuleData && htlRuleData.tbl_rules_prn
          ? htlRuleData.tbl_rules_prn.map(item => ({
              label: (
                <div>
                  <div>{item.rules_name}</div>
                  <div>Start Date: {new Date(item.start_date).toLocaleDateString('en-GB')}</div>
              <div>End Date: {new Date(item.end_date).toLocaleDateString('en-GB')}</div>
                </div>
              ),
              value: item.id_seq,
            }))
          : [];

     /*     const htlSeaItems = htlseaData && htlseaData.tbl_htl_season
          ? htlseaData.tbl_htl_season.map(item => ({
              label: (
                <div>
                  <div>{item.desc}</div>
                  <div>Start Date: {new Date(item.start_date).toLocaleDateString('en-GB')}</div>
              <div>End Date: {new Date(item.end_date).toLocaleDateString('en-GB')}</div>
                </div>
              ),
              value: item.id_seq,
            }))
          : []; */

          
  
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

   
  
    return (

        
        <>
          <Fieldset>

          <div>
  
  <Dialog visible={displayBasic2} style={{ width: '70vw' }} onHide={onHide2} header={"Rules Group"}>
    <div className={`modal-backdrop bg-slate-600  ${displayBasic2 ? 'block' : 'hidden'}`}></div>
    <div>
      <p>
    <HtlAgnOffresGrp/> 
      </p>
    </div>
  </Dialog>
  </div>
            <div className="flex">
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={contIdSeq}
                  onValueChange={(e) => setContIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>

            
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Offer Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={contSeaIdSeq}
                  onValueChange={(e) => setContSeaIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>

              <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Contract Offer Name"}
       </label>
       <Dropdown
       className="h-11 mr-5 w-56 rounded-md" 
        style={{ width: '204px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={rulesGrpClass}
         options={rulesGrpClassSelectItems}
         onChange={(e) => setRulesGrpClass(e.value)}
         placeholder={"select_a_department_holder"}
         />
       </div>
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Hotel Offer Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={htlSeaIdSeq}
                  onValueChange={(e) => setHtlSeaIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>

            

              <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Contract Offer Name"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" 
        style={{ width: '384px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={htlSeaIdSeq}
         options={htlRuleItems}
         onChange={(e) => setHtlSeaIdSeq(e.value)}
         placeholder={"select_a_department_holder"}
         />
       </div>

   
            </div>
            <br></br>
            
            <button
  className={`bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md ${
    contSeaIdSeq ? 'cursor-not-allowed opacity-50' : ''
  }`}
  onClick={contSeaIdSeq ? null : handleUpdateIdSeq}
  disabled={!!contSeaIdSeq}
>
  {contSeaIdSeq ? 'Saved Rules' : 'Save Rules'}
</button>


<button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={onClick2}
      >
        {"Offer Details"}
      </button>


      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdateButtonClick}
      >
        {"Week Days Calc"}
      </button>


      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdateButtonClick22}
      >
        {"Spacial Days Calc"}
      </button>

      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={onClickCalc}
       
      >
        {"Week Days Calca"}
      </button>

      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={() => onClickCalc2(perRuleSubData2222)}
      >
        {"Spacial Days Calca"}
      </button>



      
      

          </Fieldset>
      
          <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Offers List"}
            </span>
          }
          className="ml-5 flex"
        >
      <div>
  

      <DataTable
         value={firmData2}
         scrollable 
         scrollHeight="250px" 
         loading={loadingRuleSub}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="id_seq"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rule Id"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
        

          <Column field="rules_sub_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rules Type"}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>
          <Column field="rules_sub_name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rules Desc"}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>
  
          <Column
           field="start_date"
           header={<span className="font-bold text-sm text-gray-900">{"start_date_title"}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.start_date;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />

         
          <Column
           field="end_date"
           header={<span className="font-bold text-sm text-gray-900">{"end_date_title"}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.end_date;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           // const createUser = rowData.end_date;

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{"statusrec"}</span>}
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-sm" 
          />
          <Column
          header={<span className="font-bold text-sm text-gray-900">{"detail"}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
            //    setVarCode8(rowData.id_seq);  
                setVarCode(rowData.r_prn_id_seq);     
              //  setVarCode10(rowData.id_seq);   
                
                setVarCode11(rowData.rules_sub_type); //EBO
                setVarCode8(rowData.id_seq);
                setVarCode9("COFF")
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable>

   {/* Dialog penceresi */}
   <Dialog header={"Contract Offers Detail"} visible={displayBasic} style={{ width: '55vw' }} onHide={onHide}>
   
       <div>

         <HtlAgnOffresEdit/>
    
      
       </div>
     
   </Dialog>
 </div>

              </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Offers Rules"}
            </span>
          }
          className="ml-5 flex"
        >
    
            

              </TabPanel>
            
          </TabView>
      
          
        </>
      );
      
  };
  
  export default HtlAutoSalesOffres;

 


      
  